export const KYC_REVIEW_STATUS = {
  PENDING: "pending",
  UNDER_REVIEW: "under_review",
  APPROVED: "approved",
  REJECTED: "rejected",
  RESUBMISSION_REQUIRED: "resubmission_required",
};

export const KYC_MATCH_RESULT = {
  FULL_MATCH: "full_match",
  PARTIAL_MATCH: "partial_match",
  MISMATCH: "mismatch",
  PROVIDER_UNAVAILABLE: "provider_unavailable",
};

export const SERVICE_REQUEST_TYPE = {
  COOPERATIVE: "cooperative",
  REAL_ESTATE: "real_estate",
};

export const SERVICE_REQUEST_STATUS = {
  SUBMITTED: "submitted",
  AWAITING_CONTACT: "awaiting_contact",
  IN_PROGRESS: "in_progress",
  AWAITING_CUSTOMER: "awaiting_customer",
  INSPECTION_SCHEDULED: "inspection_scheduled",
  INSPECTION_COMPLETED: "inspection_completed",
  APPROVED: "approved",
  DECLINED: "declined",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
};

export const UPGRADE_STATUS = {
  NOT_ELIGIBLE: "not_eligible",
  ELIGIBLE: "eligible",
  UPGRADE_REQUESTED: "upgrade_requested",
};

export const KYC_REVIEW_STATUS_COLORS = {
  pending: "#FFA500",
  under_review: "#0556e5",
  approved: "#19BC31",
  rejected: "#FF4343",
  resubmission_required: "#8543f1",
};

export const SERVICE_REQUEST_STATUS_COLORS = {
  submitted: "#FFA500",
  awaiting_contact: "#ff9500",
  in_progress: "#31778C",
  awaiting_customer: "#8543f1",
  inspection_scheduled: "#0556e5",
  inspection_completed: "#31778C",
  approved: "#19BC31",
  declined: "#FF4343",
  completed: "#19BC31",
  cancelled: "#A1A0A0",
};

export const ACCOUNT_STATUS_COLORS = {
  active: "#19BC31",
  suspended: "#FF4343",
  pending_verification: "#FFA500",
};

export function maskNin(nin) {
  const digits = String(nin || "").replace(/\D/g, "");
  if (digits.length < 4) return "****";
  return `*******${digits.slice(-4)}`;
}
